module.exports = __webpack_public_path__ + "img/network_off_white.f735a3f7.png";